import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const [brandName, setBrandName] = useState("FinFlow"); // Default fallback
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBrand = async () => {
      try {
        const response = await api.get("/brand");
        if (response.data?.brand_name) {
          setBrandName(response.data.brand_name);
        }
      } catch (error) {
        console.log("Using default brand name");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBrand();
  }, []);

  // Function to refresh brand name (useful after admin updates it)
  const refreshBrand = async () => {
    try {
      const response = await api.get("/brand");
      if (response.data?.brand_name) {
        setBrandName(response.data.brand_name);
      }
    } catch (error) {
      console.log("Failed to refresh brand name");
    }
  };

  return (
    <BrandContext.Provider value={{ brandName, isLoading, refreshBrand }}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error("useBrand must be used within a BrandProvider");
  }
  return context;
}
